import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);

const routes = [
  {
    path: "/auth/login",
    name: "autentication",
    component: () => import("../views/auth/Login.vue"),
  },
  {
    path: "/auth/business",
    name: "business",
    components: {
      default: () => import("../views/auth/Business.vue"),
      appBar: () => import("../components/AppBar.vue"),
    },
  },
  {
    path: "/",
    // name: 'home',
    component: () =>
      import(/* webpackChunkName: "home" */ "../views/app/IndexPage.vue"),
    redirect: "/home",
    meta: { loginRequired: true },
  },
  {
    path: "/home",
    components: {
      default: () => import("../views/app/IndexPage.vue"),
      sideBar: () => import("../components/SideBar.vue"),
    },
    redirect: "/home",
    meta: { loginRequired: true },
    children: [
      {
        path: "/",
        name: "home",
        components: {
          default: () => import("../views/app/Home.vue"),
        },
      },
      /**
       * ==============================================================================
       *  Service
       * ==============================================================================
       */
      {
        path: "/services",
        name: "service",
        components: {
          default: () =>
            import(
              /* webpackChunkName: "home" */ "../views/app/service/IndexPage.vue"
            ),
          // sideBar: () => import('../components/SideBar.vue'),
        },
        redirect: "/services/list",
        children: [
          {
            path: "list",
            component: () => import("../views/app/service/List.vue"),
          },
          {
            path: "new",
            component: () => import("../views/app/service/New.vue"),
          },
          {
            path: ":id",
            component: () => import("../views/app/service/Update.vue"),
          },
        ],
      },
      /**
       * ==============================================================================
       *  Service closed
       * ==============================================================================
       */
      {
        path: "/services/closed",
        name: "closed",
        components: {
          default: () =>
            import(
              /* webpackChunkName: "home" */ "../views/app/service/closed/IndexPage.vue"
            ),
          // sideBar: () => import('../components/SideBar.vue'),
        },
        redirect: "/services/closed/list",
        children: [
          {
            path: "list",
            component: () => import("../views/app/service/closed/List.vue"),
          }
        ],
      },
      /**
       * ==============================================================================
       *  categories
       * ==============================================================================
       */
      {
        path: "/category",
        name: "category",
        components: {
          default: () =>
            import(
              /* webpackChunkName: "home" */ "../views/app/category/IndexPage.vue"
            ),
          // sideBar: () => import('../components/SideBar.vue'),
        },
        redirect: "/category/list",
        children: [
          {
            path: "list",
            component: () => import("../views/app/category/List.vue"),
          },
          {
            path: "new",
            component: () => import("../views/app/category/New.vue"),
          },
          {
            path: ":id",
            component: () => import("../views/app/category/Update.vue"),
          },
        ],
      },
      /**
       * ==============================================================================
       *  pay
       * ==============================================================================
       */
      {
        path: "/pay",
        name: "pay",
        components: {
          default: () => import("../views/app/pay/IndexPage.vue"),
          // sideBar: () => import('../components/SideBar.vue'),
        },
        redirect: "/pay/list",
        children: [
          {
            path: "list",
            component: () => import("../views/app/pay/List.vue"),
          },
          {
            path: "new",
            component: () => import("../views/app/pay/New.vue"),
          },
          {
            path: ":id",
            component: () => import("../views/app/pay/Update.vue"),
          },
        ],
        // beforeEnter: (to, from, next) => {
        //   const permision = JSON.parse(
        //     localStorage.getItem("employee")
        //   ).permissions;
        //   const valid = permision.some(
        //     (element) => element.value === permissions.setting[0]
        //   );
        //   if (valid) next();
        //   else next({ name: "home" });
        // },
      },
      /**
       * ==============================================================================
       *  configuration
       * ==============================================================================
       */
      {
        path: "/setting",
        name: "setting",
        components: {
          default: () =>
            import(
              /* webpackChunkName: "home" */ "../views/app/setting/Update.vue"
            ),
          // sideBar: () => import('../components/SideBar.vue'),
        },
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const employee = JSON.parse(localStorage.getItem('employee'))
  const placeBusiness = JSON.parse(localStorage.getItem('placeBusiness'))
  const business = placeBusiness || []
  console.log(to, from)
  if ((!employee || business.length === 0) && to.name != 'autentication') {
    if (from.name != 'autentication') next({ name: 'autentication' })
  }
  // if (to.name != "business" && to.name != "autentication") {
  //   const placeBusiness = JSON.parse(localStorage.getItem("placeBusiness"))
  //   if (placeBusiness.length ) {
  //     next({ name: "business" });
  //   } else if (!employee.placeBusiness.some((v) => v === placeBusiness._id)) {
  //     next({ name: "business" });
  //   }
  // }
  next();
});

export default router;
